import { ensureModuleMessages, registerModuleCatalog } from '@/shared/i18n/i18n';

// `eager`: o título do manifesto aparece no ⌘K e no breadcrumb antes de a tela abrir (A07).
registerModuleCatalog('tenant-permission-resource', (locale) => import(`./locales/${locale}.po`), {
  eager: true,
});

/** Carrega o catálogo do módulo no idioma ativo (a rota chama antes de desenhar a tela). */
export const loadTenantPermissionResourceMessages = () =>
  ensureModuleMessages('tenant-permission-resource');
